<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
        <div class="middle_section m-0">
            <div class="top_searchbars">
                <div class="row">
                    <div class="col-12">
					   <div class="cap_logo_steps centerLogo p-3 d-flex justify-content-between align-items-center">
							 <router-link to="/home"><img src="../../../../../static/website/images/logo.svg" alt="Captail wallet"></router-link>
							<div class="rightBack d-flex align-items-center">
                                <a href="#" class="backToDash" @click.prevent="logout()">Logout</a>
							    <!-- <router-link class="backToDash" :to="'/home'"><feather type="home"></feather></router-link> -->
						    </div>
						</div>
                    </div>
                </div>
            </div>
            <div class="mid_scroll_content d-flex align-items-center justify-content-center">
                <section class="stepsForm-include valigncenter border-0 w-100">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-7 stepBorder box-shadow text-center">
                            <loader v-if="pageLoader"></loader> 
                            <alert-notification v-if="notification_msg != ''"/>
                         <h3 class="text-center mb-4">Personal Information</h3>
                         <p>Please provide details of your address in the country of your residence. This is the country where you primarily reside, do banking and receive important mail.</p>
                            <form class="mt-4" >
                                <div class="row personalInfo">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">First Name</label>
                                            <input type="text" class="form-control" name="legal_name" v-model="fname" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('legal_name')" class="text-danger">First Name is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Last Name</label>
                                            <input type="text" class="form-control" name="legal_name" v-model="lname" placeholder=" ">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group active"> 
                                            <label class="labeltext">Date of Birth </label>
                                         <!-- :class="(dob != '' || dateFocus)? 'active' : ''" -->
											<!-- <datepicker class="form-control datepicker"  :typeable="true" :format="customFormatter" placeholder="MM-DD-YYYY" name="dob" v-model="dob" v-validate="'required'" :disabledDates="disabledDates" > </datepicker> -->
                                            <!-- <datepicker class="form-control datepicker"  :typeable="true" @focus="dateFocus = true" @blur="dateFocus = false" @clear="dob = ''" :format="'DD-MM-YYYY'" placeholder=" " name="dob" v-model="dob" v-validate="'required'" :disabled-date="disabledDates" :lang="'en'" > </datepicker> -->
                                            <input class="form-control datepicker" type="date" v-model="dob" name="dob" v-validate="'required'" :max="maxDate()" @focus="dateFocus = true" @blur="dateFocus = false"/>
                                            <!--<input type="text" class="form-control" name="dob" v-model="dob"  v-validate="'required'">
											<label class="labeltext">Date Of Birth</label>
                                            <label class="labeltext">Date of Birth</label>-->
											<span v-show="submitted && errors.has('dob')" class="text-danger">The Date is required</span>
                                            <span v-if="submitted && !is_18()" class="text-danger">Age should be greater than 18 Years</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">Residential Address </label>
                                            <input type="text" class="form-control" name="address"  v-model="address1" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('address')" class="text-danger">The Address is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">City </label>
                                            <input type="text" class="form-control" name="City" v-model="city" v-validate="'required'" placeholder=" ">
											<span v-show="submitted && errors.has('City')" class="text-danger">The City is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="labeltext">POSTAL Code </label>
                                            <input type="text" class="form-control" name="zip code" v-model="zip_code" v-validate="'required'" placeholder=" ">
                                            <span v-show="submitted && errors.has('zip code')" class="text-danger">{{ errors.first('zip code') }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="(residence_country != '')? 'active' : ''">
                                            <label class="labeltext">Select Residence Country </label> 
                                            <!-- <input type="text" disabled class="form-control" name="Country_Name" v-model="residence_country" v-validate="'required'" placeholder=" "> -->
                                            <v-select disabled :options="Object.values($env_var.countriesList)" :reduce="country => country.code" v-model="residence_country" label="name" placeholder=" " name="Country_Name" v-validate="'required'" :autocomplete="'off'"></v-select>
                                            <!--<select class="form-control" name="Country" v-model="residence_country" v-validate="'required'">
                                                <option value="">Select Country</option>
                                                <option :value="val.name" v-for="val in $env_var.countriesList">{{val.name}}</option>
                                            </select>-->
                                            <!-- <input type="text" class="form-control" name="Country" v-model="residence_country" v-validate="'required'">-->
                                            <span v-show="submitted && errors.has('Country_Name')" class="text-danger">The Residence Country is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group" :class="(nationality != '')? 'active' : ''">
											<label class="labeltext">Select Nationality </label>
                                            <v-select :options="Object.values($env_var.countriesList)" :reduce="country => country.code" v-model="nationality" label="name" placeholder=" " name="nationality" v-validate="'required'" :autocomplete="'off'"></v-select>
                                             <!--<select class="form-control" name="nationality" v-model="nationality" v-validate="'required'">
                                                <option value="">Select Nationality</option>
                                                <option :value="val.name" v-for="val in $env_var.countriesList">{{val.name}}</option>
                                            </select>
                                             <input type="text" class="form-control" name="nationality" v-model="nationality" v-validate="'required'">
                                            <label class="labeltext">Nationality </label> -->
                                            <span v-show="submitted && errors.has('nationality')" class="text-danger">The Nationality is required</span>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-left">
                                        <h5>Are you a politically exposed person (PEP) ? *</h5>
                                        <div class="form-group mb-3">
                                            <label class="customRadioButton">Yes
                                              <input type="radio" value="1" name="radio" v-model="pep" v-validate="'required'">
                                              <span class="checkmark"></span> 
                                            </label>
                                        </div>
                                        <div class="form-group">
                                            <label class="customRadioButton">No
                                              <input type="radio" value="0"  name="radio" v-model="pep" v-validate="'required'">
                                              <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <span v-show="submitted && errors.has('radio')" class="text-danger">field is required</span>
                                    </div>
									<div class="col-md-12 text-left" v-if="residence_country == 'US' || nationality == 'US'">
                                        <h5>Are you a US person ?</h5>
                                        <div class="form-group mb-3">
                                            <label class="customRadioButton sequare">Yes
                                              <input type="checkbox" true-value="1" false-value="0"  name="us_person" v-model="us_person" >
                                              <span class="checkmark"></span> 
                                            </label>
                                        </div>
                                        
                                        <p class="alert alert-danger" v-if="us_person == 1">Unfortunately, due to regulatory restrictions we cannot accept clients from your country of residence and/or citizenship</p>
                                    </div>
                                    <div class="col-12">
                                        <div class="submitButton text-center mt-md-4 mt-3">
                                            <input type="button" class="cap_btn blue px-4 large_btn" value="Save & Continue" :class="(pageLoader || pep == 1)?'disabled':''" v-on:click.stop.prevent="submit" v-if="us_person == 0">
                                            <input type="button" class="cap_btn blue px-4 large_btn" value="Save & Continue" :class="(us_person == 1 || pep == 1)?'disabled':''" v-on:click.stop.prevent="" v-else>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as types from '@/types'
export default {
    name: 'step-four',
    mixins: [registerStepsMixins],
    data() {
        return {
			submitted : false,
			pageLoader : false,
            notification_msg:'',
            notification_type:'',
			pep : '0',
            us_person : '0',
			fname : '',
            lname: '',
			dob : '',
            dateFocus : false,
			address1 : '',
			nationality : '',
			city : '',
            zip_code : '',
			residence_country : '',
            // disabledDates: {
            //     from: new Date(),
            // },
            // limit:{min: '01/01/1900', max: new Date()},
		}
    },
	watch: {
		residence_country: function (val) {
		  if(val != 'US' && this.nationality != 'US'){
			this.us_person = '0'
		  }
		},
        // dob(val){
        //     console.log(val,moment(val))
        // }
	 },
	methods: {
        maxDate(){
           return moment().format('YYYY-MM-DD');
        },
        disabledDates(date){
            return Date.parse(date) <= Date.parse(new Date())
        },
		customFormatter(date) {
		console.log(date)
		  return moment(date).format('MM-DD-YYYY');
		},
        is_18(){
            var dob = new Date(this.dob);
            let get_year = new Date().getFullYear() - 18
            if(!this.dob) return false;
            else if(dob.getFullYear() > get_year) return false;
            else if(dob.getFullYear() < get_year) return true;
            else return false;
        },
		submit(){
            if(this.pageLoader){return;}

			const _that = this
			this.submitted = true;
			this.$validator.validate().then(valid => {
				if (valid && _that.is_18()) {    
					let input_json={
						'globalParams' :{
							"pep" : _that.pep,
                            "us_person" : _that.us_person,
							"fname" : _that.fname, 
                            "lname" : _that.lname,
							"dob" : moment(_that.dob).format() , 
							"address1" : _that.address1, 
							"city" : _that.city, 
                            "zip_code" : _that.zip_code.toString(), 
							"nationality" : _that.nationality, 
							"residence_country" : _that.residence_country,
							'step' : '1'
						},
						'localParams' :{ "parameter" : _that }
					}
					//console.log(input_json)
					_that._runStep4(input_json)
				}
			})
		},
        ...mapActions({
            _runLogout: types.RUN_LOGOUT
        }),
        logout(){
            let input_json={
                'globalParams' :{},
                'localParams' :{ "parameter" : this }
            }
            this._runLogout(input_json)
        },
	},
	created(){
		this._runGetStepInfo({'globalParams' :{"step" : '1'},'localParams' :{ "parameter" : this}})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/individual/individual_step1.vue